import React from "react";

export class CardImageWithLoad extends React.Component {
  constructor(props) {
    super(props);
    this.checkImages(props.url);
    this.state = {
      isValidUrl: false
    };
  }

  checkImages = url => {
    const img = new Image();
    img.onload = () => {
      this.setState({
        isValidUrl: true
      });
    };
    img.onerror = () => {
      this.setState({
        isValidUrl: false
      });
    };
    img.src = url;
  };

  render() {
    return (
      <img
        src={
          this.state.isValidUrl
            ? this.props.url
            : this.props.useNoScreenshot
            ? require("../assets/images/no-screenshot-available.png")
            : require("../assets/images/no-thumbnails-available.png")
        }
        alt="Cardcap"
        className={this.props.className}
      />
    );
  }
}
